export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    type: 'expand',
    width: 70,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: {
      content: 'expandContent',
    },
  },
  {
    title: that.$l('INDEX.order_form_label_fabric_no') || '面料编号',
    field: 'fabricNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_fabricDisplayName') || '面料显示名称',
    field: 'fabricDisplayName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fabricWidth') || '面料门幅',
    field: 'fabricWidth',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_fabric_weight') || '面料克重',
    field: 'fabricWeight',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_fabric_unit') || '面料单位',
    field: 'fabricUnit',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_isSpecify') || '客户指定供应商',
    field: 'isSpecify',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    slots:{
      default:"specifyslot"
    }
  },
  {
    title: that.$l('form_label_scmName') || '供应商名称',
    field: 'scmName',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_needTotalQty') || '总需求数量',
    field: 'needQty',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_hasKTotalQty') || '已采购总数',
    field: 'hasQty',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_stockTotalQty') || '已入库总数',
    field: 'stockQty',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人姓名',
    field: 'modifyByName',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyDate',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
